import { render, staticRenderFns } from "./enrolled.vue?vue&type=template&id=3bc247da&scoped=true&lang=html&"
import script from "./enrolled.vue?vue&type=script&lang=js&"
export * from "./enrolled.vue?vue&type=script&lang=js&"
import style0 from "./enrolled.vue?vue&type=style&index=0&id=3bc247da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc247da",
  null
  
)

export default component.exports